var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Dialog, DialogContent, AppBar, Toolbar, IconButton, Box, } from '@mui/material';
import { CloseDialogIcon, BackIcon } from '../atoms/Icons';
var SidebarDialog = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, children = _a.children, open = _a.open, _b = _a.keepMounted, keepMounted = _b === void 0 ? false : _b, onClose = _a.onClose, onBack = _a.onBack, _c = _a.contentProps, contentProps = _c === void 0 ? {} : _c, maxWidth = _a.maxWidth;
    return (React.createElement(Dialog, { keepMounted: keepMounted, open: open, onClose: onClose, maxWidth: maxWidth, hideBackdrop: true, PaperProps: {
            square: true,
            sx: {
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                m: 0,
                maxHeight: 'inherit',
                width: '100%',
                borderRadius: 0,
            },
        } },
        React.createElement(AppBar, { sx: {
                position: 'relative',
                backgroundColor: 'white',
                boxShadow: '0 1px 0 rgba(145, 158, 171, .24)',
                color: function (theme) { return theme.customPalette.text.primary; },
            } },
            React.createElement(Toolbar, null,
                onBack && (React.createElement(IconButton, { color: "inherit", onClick: onBack, sx: { mr: 2 } },
                    React.createElement(BackIcon, null))),
                React.createElement(Box, { component: 'h6', sx: {
                        flex: 1,
                        typography: function (theme) { return theme.customTypography.h6; },
                        my: 3,
                    } },
                    title,
                    subTitle && (React.createElement(Box, { component: 'p', sx: {
                            fontWeight: '400',
                            typography: function (theme) { return theme.customTypography.body2; },
                            m: 0,
                        } }, subTitle))),
                React.createElement(IconButton, { edge: "start", color: "inherit", onClick: onClose, "aria-label": "close", size: "large" },
                    React.createElement(CloseDialogIcon, null)))),
        React.createElement(DialogContent, __assign({ sx: {
                padding: {
                    xs: '24px 16px',
                    md: '32px 40px',
                },
            } }, contentProps), children)));
};
export default SidebarDialog;
